import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDeleteClient } from "@/hooks/clients/use-clients";
import type { Client } from "@/types/clients/api-types/client-types";
import { toast } from "sonner";

interface DeleteClientDialogProps {
  client: Client | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteClientDialog({
  client,
  open,
  onOpenChange,
}: DeleteClientDialogProps) {
  const deleteClient = useDeleteClient();

  const handleDeleteConfirm = () => {
    if (client) {
      deleteClient.mutate(client.id, {
        onSuccess: () => {
          toast.success(
            `Client "${client.first_name} ${client.last_name}" deleted successfully`
          );
          onOpenChange(false);
        },
        onError: () => {
          toast.error(
            `Failed to delete client "${client.first_name} ${client.last_name}"`
          );
          onOpenChange(false);
        },
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Client</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{client?.first_name}{" "}
            {client?.last_name}"?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={deleteClient.isPending}
            className="w-24"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDeleteConfirm}
            disabled={deleteClient.isPending}
            className="w-24"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
